import { Observable } from "rxjs";
import api from "../api-config/rxjs-config";

export class MediasRest {
  getMedia(id:string): Observable<any> {
    const url: string = `/media/${id}`;
    return api.get(url, {});
  }
}
